import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  [ORDER_FULFILLMENT_STATUSES.REJECTED]: 'Bestellung storniert',
  [ORDER_FULFILLMENT_STATUSES.CREATED]: 'Bestellung erhalten',
  [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: 'Bestätigung erhalten',
  [ORDER_FULFILLMENT_STATUSES.PREPARING]: 'Wird vorbereitet',
  [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: 'Unterwegs zu dir',
  [ORDER_FULFILLMENT_STATUSES.READY]: 'Bereit zur Abholung',
  status: {
    actual: 'Aktuell',
    pending: 'Ausstehend',
  },
  warning_label: {
    pickup_time_changed: '{{company}} änderte die Zeit von {{initialTime}} auf {{currentTime}}',
  },
  labels: {
    order_number: 'Bestell Nr: {{number}}',
  },
};
